<template>
  <div id="app">
    <Notifications v-if="ready && isActive" />

    <router-view v-if="ready && isActive" />
    <div v-else>
      <img style="width:100%" src alt />
    </div>
  </div>
</template>

<script>
import AuthService from "@/service/auth_service";
import http from "@/service/http";
import Notifications from "@/views/dashboard/components/Notifications";

export default {
  name: "DashboardCoreView",

  components: { Notifications },
  computed: {
    ready: function() {
      return this.$store.getters.isReady;
    },
    isActive: function() {
      if (!this.$store.getters.accountType) {
        this.$router.replace("/signup");
      } else {
        if (
          !this.$store.getters.isActive &&
          this.$store.getters.accountType != "none"
        ) {
          console.log("To Billing");
          this.goToBilling();
        }
      }
      return this.$store.getters.isActive;
    },
    accountType: function() {
      return this.$store.getters.accountType;
    }
  },
  methods: {
    async goToBilling() {
      let urlCreateStripeSesion = "plans/portal";
      let response = await http.get(urlCreateStripeSesion);
      window.location.href = response.data.url;
    }
  },
  watch: {
    isActive() {
      if (!this.isActive) this.goToBilling();
    }
  },
  mounted() {
    AuthService.onAuthStateChanged(user => {
      if (user) {
        // TODO Number of steps should be put in a const somewhere
        if (AuthService.emailVerified) {
          // TODO Wait for ready
          // TODO Change for this.$.store.getters.restaurant.config.defaultView
          if (this.ready) {
            if (this.$store.getters.restaurant.startStep < 3) {
              this.$router.replace("signup");
            }
            if (!this.isActive) this.goToBilling();
          }
        } else {
          if (!this.$router.history.current.path.includes("/login")) {
            // alert(this.$router.history.current.path);
            this.$router.replace("/signup");
          }
        }
      } else {
        this.$router.replace("/login");
      }
    });
  }
};
</script>
